import {HostMaps} from 'hiya-common/src/utils/host/AutoHost'
import {SPORTTAB} from './interface'

export const TAB_STR_MAP = {
  [SPORTTAB.Normal]: 'normal',
  [SPORTTAB.Advanced]: 'advanced',
  [SPORTTAB.Master]: 'master',
}

const BET_STORAGE_KEY = {
  [SPORTTAB.Normal]: 'gs_normal_bet_amount',
  [SPORTTAB.Advanced]: 'gs_advanced_bet_amount',
  [SPORTTAB.Master]: 'gs_master_bet_amount',
}

export const getLocalBet = (tab: SPORTTAB): number => {
  return Number(localStorage.getItem(BET_STORAGE_KEY[tab]) || 0)
}

export const setLocalBet = (tab: SPORTTAB, amount: number) => {
  localStorage.setItem(BET_STORAGE_KEY[tab], String(amount))
}

// 使用静态路径供 Webpack 静态分析，避免 "Critical dependency: require function..." 警告
const numContextByTab = {
  [SPORTTAB.Normal]: require.context('./images/ting/1/num', false),
  [SPORTTAB.Advanced]: require.context('./images/ting/2/num', false),
  [SPORTTAB.Master]: require.context('./images/ting/3/num', false),
}

export const getNumSrc = (num: number, tab: SPORTTAB) => {
  const numPng = numContextByTab[tab]
  if (!numPng) return undefined
  const src = numPng.keys().find((v) => v === `./${num}.png`)
  return src ? numPng(src) : undefined
}

export const getGameId = (path = '') => {
  const arr = (path || window.location.pathname).split('/')
  return Number(arr[arr.length - 1])
}

/**
 * 顺时针位置映射：position[n] 的下一个位置是 position[n+1]。
 * 这里 position 指 CLOCKWISE_ORDER 中的下标(0-7)，与 item 数组下标通过 CLOCKWISE_ORDER 互转。
 */
export const CLOCKWISE_ORDER = [7, 5, 3, 1, 0, 2, 4, 6]
export const mapChangeFinger = [1, 2, 3, 4, 5, 6, 7, 0]
const mapBoxIndex = [0, 1, 2, 3, 4, 5, 6, 7]

export const getAfterDrawMapBox = ({
  nextIndex,
  targetIndex,
}: {
  nextIndex: number
  targetIndex: number
}) => {
  const distance = targetIndex - nextIndex
  if (distance === 0) {
    return mapBoxIndex
      .slice(nextIndex)
      .concat(mapBoxIndex.slice(0, targetIndex + 1))
  }
  if (distance > 0) {
    if (distance >= 3) {
      return mapBoxIndex.slice(nextIndex, targetIndex + 1)
    }
    return mapBoxIndex
      .slice(nextIndex)
      .concat(mapBoxIndex.slice(0, targetIndex + 1))
  }
  if (distance < 0) {
    const normalArr = mapBoxIndex
      .slice(nextIndex)
      .concat(mapBoxIndex.slice(0, targetIndex + 1))
    if (normalArr.length < 3) {
      return mapBoxIndex
        .slice(nextIndex)
        .concat(mapBoxIndex, mapBoxIndex.slice(0, targetIndex + 1))
    }
  }
  return mapBoxIndex
    .slice(nextIndex)
    .concat(mapBoxIndex.slice(0, targetIndex + 1))
}

const GS_REAPT_KEY = 'gs_reapt'

export const getReaptShown = (): boolean => {
  return localStorage.getItem(GS_REAPT_KEY) === '1'
}

export const setReaptShown = () => {
  localStorage.setItem(GS_REAPT_KEY, '1')
}

/** 音效开关 storage key：存 '1' 表示关闭音效 */
export const GS_MUSIC_KEY = 'greedySports_Music'

/** 获取当前音效状态：true 播放，false 不播放（与 storage 一致） */
export const getMyMusic = (): boolean => {
  return localStorage.getItem(GS_MUSIC_KEY) !== '1'
}

/** 持久化音效状态，play 为 true 表示开启、false 表示关闭 */
export const setLocalMusic = (play: boolean) => {
  if (play) {
    localStorage.removeItem(GS_MUSIC_KEY)
  } else {
    localStorage.setItem(GS_MUSIC_KEY, '1')
  }
}

const imagesContext = require.context('./images', true, /\.png$/)

export const getAllPreImg = (
  getImgConf?: (key: string) => string
): string[] => {
  const localImgs = imagesContext
    .keys()
    .filter(
      (key) => !key.startsWith('./modal/') && !key.startsWith('./subPage/')
    )
    .map((key) => imagesContext(key))

  const {fileTree} = require('./config')
  const fileTreeImgs: string[] = fileTree.map((key: string) =>
    getImgConf ? getImgConf(key) : require(`./images/${key}`)
  )

  return [...new Set([...localImgs, ...fileTreeImgs])]
}

export const getAllAfterImg = (): string[] => {
  return imagesContext
    .keys()
    .filter((key) => key.startsWith('./modal/') || key.startsWith('./subPage/'))
    .map((key) => imagesContext(key))
}

export const audio = [
  `${HostMaps.prod.img01}/download/file?obj=mefile/hyfo/76/70/9d8e-1d1f-11f1-9c9f-00163e04069f`, // 吹哨子
  `${HostMaps.prod.img01}/download/file?obj=mefile/hyfo/a7/62/39f9-1d1f-11f1-9c9f-00163e04069f`, // 没提进
  `${HostMaps.prod.img01}/download/file?obj=mefile/hyfo/29/e8/2671-1d20-11f1-9c9f-00163e04069f`, // 提进
  `${HostMaps.prod.img01}/download/file?obj=mefile/hyfo/45/96/a38f-1d20-11f1-9c9f-00163e04069f`, // 图标亮开奖音效
  `${HostMaps.prod.img01}/download/file?obj=mefile/hyfo/46/57/19a0-2824-11f1-9c9f-00163e04069f`, // 下注点击音效
  `${HostMaps.prod.img01}/download/file?obj=mefile/hyfo/8a/10/4000-1d20-11f1-beeb-00163e0442bb`, // 中奖欢呼音效
]
